import { backButton } from '@telegram-apps/sdk-react';
import { useEffect, useRef } from 'react';

/**
 * Shows the Telegram back button while the calling screen is mounted and routes taps to `onBack`.
 * Screens use this instead of touching the SDK, so the button can never stay visible after the
 * screen that owns it is gone.
 */
export const useBackButton = (onBack: () => void): void => {
  const handler = useRef(onBack);

  useEffect(() => {
    handler.current = onBack;
  }, [onBack]);

  // Empty dependencies on purpose: a handler that legitimately changes with the form step would
  // otherwise hide and show the native button on every step, which reads as flicker in Telegram.
  useEffect(() => {
    if (!backButton.show.isAvailable() || !backButton.onClick.isAvailable()) {
      return;
    }

    backButton.show();
    const stopListening = backButton.onClick(() => {
      handler.current();
    });

    return () => {
      stopListening();

      if (backButton.hide.isAvailable()) {
        backButton.hide();
      }
    };
  }, []);
};
